<script setup>
import { DialogDescription } from "reka-ui";
import { cn } from "@/shared/lib/utils";
const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <DialogDescription
    data-slot="sheet-description"
    :class="cn('text-muted-foreground text-sm', props.class)"
  >
    <slot />
  </DialogDescription>
</template>
